define.alias("shared/components/shared/video-thumbnail-list", "preview-grid/components/shared/video-thumbnail-list");